import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const ensureFeatures = (center) =>
  center
    ? {
        ...center,
        features: center.features ?? {},
      }
    : center;

const addCenter = (center, oldRecents) => {
  const normalizedCenter = ensureFeatures(center);

  if (oldRecents.some(({ uuid }) => uuid === normalizedCenter.uuid))
    return { recents: oldRecents };

  return {
    recents: [normalizedCenter, ...oldRecents].slice(0, 5),
  };
};

const useBowlingCentersStore = create(
  persist(
    (set) => ({
      current: null,
      recents: [],
      addCurrentCenter: (center) => {
        set({ current: ensureFeatures(center) });
      },
      addRecentCenter: (center) => {
        set(({ recents }) => addCenter(center, recents));
      },
      updateRecents: (newRecents) => {
        set({
          recents: newRecents.map(ensureFeatures).slice(0, 5),
        });
      },
    }),
    {
      name: 'lt-bowling-centers',
      onRehydrateStorage: () => (state) => {
        if (!state) return;
        state.current = ensureFeatures(state.current);
        state.recents = state.recents?.map(ensureFeatures) ?? [];
      },
    }
  )
);

export default useBowlingCentersStore;
